import { ref } from "vue";

/**
 * @NOTE: This doesn't exist in API form. It's set based on the data of the membership type state
 * 
 * @returns {Object<details: Ref<Object>>}
 */
export default function createAnswerData(){
    const details = ref({})

    return {
        details: details,
    }
}